import React from 'react'
import {
    NavigationMenuInlineAddParams,
    NavigationMenuInlineAddType
} from "../../../menu-items/menu-add-with-popover/popover";
import NavigationMenuItemAddFolder from "../../../menu-items/project/add/menu-item-add-folder"
import NavigationMenuItemAddPage from "../../../menu-items/project/add/menu-item-add-page"
import NavigationMenuItemAddGroup from "../../../menu-items/project/add/menu-item-add-group"
import NavigationMenuItemAddLink from "../../../menu-items/project/add/menu-item-add-link"
import NavigationMenuItemAddEmbed from "../../../menu-items/project/add/menu-item-add-embed"

type Props = {
    className?      : string

    type            : NavigationMenuInlineAddType
    level?          : number
    params          : NavigationMenuInlineAddParams
    parentId?       : ID

    callback        : callback
}

export default function NavigationMenu_ProjectsInlineAdd(props: Props) {

    switch (props.type) {

        case NavigationMenuInlineAddType.FOLDER:
            return <NavigationMenuItemAddFolder level       = {props.level}
                                                params      = {props.params}
                                                parentId    = {props.parentId}
                                                onAdded     = {props.callback}/>

        case NavigationMenuInlineAddType.PAGE:
            return <NavigationMenuItemAddPage level         = {props.level}
                                              parentId      = {props.parentId}
                                              templateId    = {props.params?.templateId}
                                              onAdded       = {props.callback}/>

        case NavigationMenuInlineAddType.GROUP:
            return <NavigationMenuItemAddGroup level    = {props.level}
                                               parentId = {props.parentId}
                                               onAdded  = {props.callback}/>

        case NavigationMenuInlineAddType.LINK:
            return <NavigationMenuItemAddLink level     = {props.level}
                                              parentId  = {props.parentId}
                                              onAdded   = {props.callback}/>

        case NavigationMenuInlineAddType.EMBED:
            return <NavigationMenuItemAddEmbed level    = {props.level}
                                               parentId = {props.parentId}
                                               params   = {props.params}
                                               onAdded  = {props.callback}/>
    }

}
